
// Utils

import { transformDropdownOptionsToObject } from '../normalize/transformDropdownOptionsToObject';

// Constants

import { FREQUENCY_TYPES } from '../../constants/ssap/hhmTypes/frequencyTypes';
import { DROPDOWN_OPTIONS } from '../../constants/ssap/hhmTypes/dropdownOptions';


export const getFrequencyId = (frequency, shouldNotProcess = undefined) => {

    const FREQUENCIES_LIST = transformDropdownOptionsToObject(DROPDOWN_OPTIONS.FREQUENCY);

    if(shouldNotProcess) {
        return FREQUENCIES_LIST[frequency];
    }

    switch(frequency) {
        case FREQUENCY_TYPES.DAILY:
            return 'common.day_frequency_and_cycles';
        case FREQUENCY_TYPES.HOURLY:
            return 'common.hour_frequency_and_cycles';
        default:
            return FREQUENCIES_LIST[frequency];
    }
};